import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../redux/App/App.slice';
import PersonWithCatIcon from '../../components/Icons/Person/PersonWithCat.icon';

const StyledInDevelopingPageTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
`;
const StyledInDevelopingPageCode = styled.div``;
const StyledInDevelopingPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  min-height: 100%;
`;

const InDevelopingPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(setHeaderTitle('Page in developing'));
  }, [dispatch]);

  return (
    <StyledInDevelopingPage>
      <StyledInDevelopingPageCode>
        <PersonWithCatIcon />
      </StyledInDevelopingPageCode>
      <StyledInDevelopingPageTitle>
        {t('Module in developing')}
      </StyledInDevelopingPageTitle>
    </StyledInDevelopingPage>
  );
};

export default InDevelopingPage;
